  const useIsOpening = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const isOpening = searchParams.get("opening") === "true";
    const openingType = parseInt(searchParams.get("type"), 10);
    return { isOpening, openingType };
  };

  export default useIsOpening;
